import gql from 'graphql-tag';

export const SALES_SEARCH_CUSTOMERS_QUERY = gql`
  query getSalesSearchCustomers($name: String, $pagination: PaginationAttributes) {
    customers(name: $name, pagination: $pagination) {
      id
      firstName
      fullName
      picture
      email
      mobilePhone
    }
  }
`;

export const REGISTER_DOCUMENTS_QUERY = gql`
  query getRegisterDocuments(
    $view: RegisterDocumentView!
    $search: String
    $locationId: ID
    $dataScope: DataScope
    $pagination: PaginationAttributes
  ) {
    registerDocuments(
      view: $view
      search: $search
      locationId: $locationId
      dataScope: $dataScope
      pagination: $pagination
    ) {
      id
      number
      issuedAt
      dueDate
      totalAmountInclTaxExempt
      paymentStatus
      order {
        id
        number
        location {
          id
          name
        }
        employeeNames
        customer {
          fullName
          email
        }
      }
    }
  }
`;
